import { render, staticRenderFns } from "./QuestionContentOld.vue?vue&type=template&id=fe03405e&scoped=true"
import script from "./QuestionContentOld.vue?vue&type=script&lang=ts"
export * from "./QuestionContentOld.vue?vue&type=script&lang=ts"
import style0 from "./QuestionContentOld.vue?vue&type=style&index=0&id=fe03405e&prod&lang=scss&scoped=true"
import style1 from "./QuestionContentOld.vue?vue&type=style&index=1&id=fe03405e&prod&lang=scss"
import style2 from "./QuestionContentOld.vue?vue&type=style&index=2&id=fe03405e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe03405e",
  null
  
)

export default component.exports